var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.59375L3.92188 13.6719",
    stroke: "#FF0000",
    strokeWidth: 1.25977
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92187 3.59375L14 13.6719",
    stroke: "#FF0000",
    strokeWidth: 1.25977
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed);
export default __webpack_public_path__ + "static/media/icon_close_red.8023952289dee67f3aa1983ce23759f7.svg";
export { ForwardRef as ReactComponent };